import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FileUploadModule } from '@iplab/ngx-file-upload';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localePt from '@angular/common/locales/pt';
import localeRu from '@angular/common/locales/ru';
import localeTh from '@angular/common/locales/th';
import localeVi from '@angular/common/locales/vi';
import localeZh from '@angular/common/locales/zh';
import localeTr from '@angular/common/locales/tr';
import localeHu from '@angular/common/locales/hu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    EvoModule
} from '@evonik/evo';
import { AppRoutingModule, routes} from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { UserService } from './core/services/user.service';
import { LanguageService } from './core/services/language.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageInterceptor } from './core/interceptors/langauge';
import { AuthAdapter, ConfigModule } from '@evonik/ng-core';
import { AuthOauth2NgModule, AuthOauth2NgService } from '@evonik/ng-auth-oauth2';
import { provideRouter, withDisabledInitialNavigation } from '@angular/router';

registerLocaleData(localeDe);
registerLocaleData(localeFr);
registerLocaleData(localeZh);
registerLocaleData(localeJa);
registerLocaleData(localePt);
registerLocaleData(localeRu);
registerLocaleData(localeEs);
registerLocaleData(localeIt);
registerLocaleData(localeVi);
registerLocaleData(localeHu);
registerLocaleData(localeTr);

registerLocaleData(localeTh);
registerLocaleData(localeKo);

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        FileUploadModule,
        ReactiveFormsModule,
        CoreModule,
        EvoModule,
        ConfigModule,
        AuthOauth2NgModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
    ],
    providers: [
        provideRouter(routes, 
            //let app initializer finished first, and we trigger route in app.component.ts
            withDisabledInitialNavigation()
        ),
        {
            provide: LOCALE_ID,
            deps: [LanguageService],      //some service handling global settings
            useFactory: (languageService: LanguageService) => languageService.locale  //returns locale string
        },
        UserService,
        { provide: AuthAdapter, useClass: AuthOauth2NgService },
        { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}